// Basket-wide checks (Q2): the same deck twice, more than 4 copies of one card across the basket (basic Energy
// excepted), more than 1 ACE SPEC per deck group. The engine's POST /basket/check is the source of truth; when it is
// not available a local fallback covers the first two from the cart's hidden line properties (_deck_id, _card_id).
import { api } from './singles-hub--api.js?v=c7c57de095';
import { pretty } from './singles-hub--format.js?v=c7c57de095';

const isBasicEnergy = (cid) => /^basic-[a-z]+-energy$/.test(cid || '');
const prettyId = (cid) => pretty(String(cid || '').split('-').map((w) => (w === 'ex' ? 'ex' : w.charAt(0).toUpperCase() + w.slice(1))).join(' '));

// lines: [{variant_id, qty, deck_id?, deck_name?, card_id?}]
export function localWarnings(lines) {
  const out = [];
  const decks = new Map();
  lines.forEach((l) => { if (!l.deck_id) return; const d = decks.get(l.deck_id) || { id: l.deck_id, name: l.deck_name || 'Deck', cards: {} }; if (l.card_id) d.cards[l.card_id] = (d.cards[l.card_id] || 0) + l.qty; decks.set(l.deck_id, d); });
  const ds = [...decks.values()];
  for (let i = 0; i < ds.length; i++) for (let j = i + 1; j < ds.length; j++) {
    const a = ds[i].cards, b = ds[j].cards;
    const ka = Object.keys(a), kb = Object.keys(b);
    if (!ka.length || !kb.length) continue;
    const shared = ka.filter((k) => b[k]).length;
    if (shared / Math.min(ka.length, kb.length) >= 0.75) out.push({ kind: 'duplicate_deck', deck_id: ds[j].id, other_deck_id: ds[i].id, text: `${pretty(ds[j].name.split(' · ')[0])} is in your basket twice.` });
  }
  const per = {};
  lines.forEach((l) => { if (l.card_id && !isBasicEnergy(l.card_id)) per[l.card_id] = (per[l.card_id] || 0) + l.qty; });
  Object.entries(per).filter(([, n]) => n > 4).forEach(([cid, n]) => out.push({ kind: 'over_copies', card_id: cid, text: `${n} copies of ${prettyId(cid)} across your basket (a deck can play 4).` }));
  return out;
}

export async function basketWarnings(lines) {
  if (!lines.length) return [];
  try {
    const r = await api.basketCheck(lines.map((l) => ({ variant_id: l.variant_id, qty: l.qty, deck_id: l.deck_id || undefined })));
    if (r && Array.isArray(r.warnings)) return r.warnings.map((w) => (typeof w === 'string' ? { kind: 'info', text: w } : Object.assign({}, w, { text: w.text || w.message || w.warning || '', deck_id: w.action && w.action.deck_id ? w.action.deck_id : w.deck_id, other_deck_id: w.other_deck_id || (w.deck_ids || []).find((d) => !(w.action && d === w.action.deck_id)) })));
  } catch (e) { /* engine without /basket/check, or offline: fall back */ }
  return localWarnings(lines);
}

export const cartLines = (c) => (c ? c.items : []).map((l) => ({ variant_id: l.variant_id, qty: l.qty, deck_id: l.deck_id, deck_name: l.deck_name, card_id: l.card_id }));
